<!--预览图片-->
<template>
  <div class="root-container">
    <div v-for="item in pics" :key="item">
      <el-image
        :src="item"
        :fit="contain"></el-image>
    </div>
  </div>
</template>

<style>

</style>

<script>


  export default {
    name: 'VisitPics',
    props: {
      pics:Array
    },
    data() {
      return {

      }
    },
    created(){
      this.initData();

    },
    methods: {

      initData(){


      },


    },


  }
</script>






// WEBPACK FOOTER //
// src/views/components/VisitPics.vue